import type { TPageTranslations } from '@crehana/i18n';

import { ATS_PUBLIC_CANDIDATE_FORM } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof ATS_PUBLIC_CANDIDATE_FORM> = {
  [ATS_PUBLIC_CANDIDATE_FORM]: {
    BANNER_PREVIEW_FORM:
      'Esta visualização do formulário é apenas informativa, portanto, não permite carregar arquivos ou enviá-lo.',
    // Not found status
    CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND: 'Formulário não encontrado',
    CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND:
      'Tente novamente em alguns minutos',
    // Closed status
    CANDIDATE_FORM_STATUS_TITLE_CLOSED: 'O período de inscrição terminou',
    CANDIDATE_FORM_STATUS_SUBTITLE_CLOSED: 'Obrigado pelo seu interesse!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_CLOSED:
      'Em breve estaremos publicando novas oportunidades de emprego.',
    // Success status
    CANDIDATE_FORM_STATUS_TITLE_SUCCESS: 'Recebemos sua candidatura!',
    CANDIDATE_FORM_STATUS_SUBTITLE_SUCCESS:
      'Obrigado pelo seu interesse em trabalhar conosco!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_SUCCESS:
      'Entraremos em contato em breve sobre o status de sua candidatura.',
    // Error page
    ERROR_PAGE_TITLE_CANDIDATE_FORM: 'Ocorreu um erro',
    ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM:
      'Clique no botão para tentar carregar novamente.',
    RETRY: 'Tentar novamente',
  },
};
